export default __webpack_public_path__ + "static/media/viberr.7625bdd9.png";